export const SIZE = 4;
export const START_TILES = 2;

export const TILE_COLORS = {
  2: 'bg-[#eee4da]',
  4: 'bg-[#ede0c8]',
  8: 'bg-[#f2b179]',
  16: 'bg-[#f59563]',
  32: 'bg-[#f67c5f]',
  64: 'bg-[#f65e3b]',
  128: 'bg-[#edcf72]',
  256: 'bg-[#edcc61]',
  512: 'bg-[#edc850]',
  1024: 'bg-[#edc53f]',
  2048: 'bg-[#edc22e]',
};

export const POWERUP_LABELS = {
  freeze: 'Freeze',
  shuffle: 'Shuffle',
  garbage: 'Garbage',
  clear: 'Clear',
  colors: 'Colors',
  targetedGarbage: 'Ziel-Garbage',
  undo: 'Undo',
  switchTiles: 'Switch',
  deleteTile: 'Delete Tile',
};

export const BLOCK_TYPE = 'block';
export const NUMBER_TYPE = 'number';
